import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../common/user';
import { Page } from '../common/page';
import { environment } from '../../environments/environment';

export interface UserProfile {
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  cellphone: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private adminUrl: string = `${environment.apiUrl}/admin/users`;
  private usersUrl: string = `${environment.apiUrl}/users`;

  constructor(private httpClient:HttpClient) { }

  // Get authenticated user profile
  getProfile(): Observable<UserProfile> {
    return this.httpClient.get<UserProfile>(`${this.usersUrl}/profile`);
  }

  // Public user methods
  getUserById(id:number):Observable<User>{
    return this.httpClient.get<User>(`${this.usersUrl}/${id}`);
  }

  // Admin methods
  getUsers(page: number, size: number, query?: string): Observable<Page<User>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    if (query) {
      params = params.set('query', query);
    }
    return this.httpClient.get<Page<User>>(this.adminUrl, { params: params });
  }

  createUser(user: Partial<User>): Observable<User> {
    return this.httpClient.post<User>(this.adminUrl, user);
  }

  updateUser(id: number, user: Partial<User>): Observable<User> {
    return this.httpClient.put<User>(`${this.adminUrl}/${id}`, user);
  }

  deleteUser(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.adminUrl}/${id}`);
  }

}
